import React from 'react';
import PropTypes from 'prop-types';
import './ChatWindow.css';


const TypingIndicator = ({ names = [] }) => {
  if (!names.length) return null;
  // FIX L-5: Show individual names instead of generic "multiple people"
  let label;
  if (names.length === 1) {
    label = `${names[0]} is typing`;
  } else if (names.length <= 3) {
    label = `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]} are typing`;
  } else {
    label = `${names.slice(0, 2).join(', ')} and ${names.length - 2} others are typing`;
  }
  return (
    <div className="typing-indicator" aria-label={label}>
      <span>{label}</span>
      <div className="typing-indicator__dots">
        <span className="typing-indicator__dot" />
        <span className="typing-indicator__dot" />
        <span className="typing-indicator__dot" />
      </div>
    </div>
  );
};

// FIX M-11: PropTypes validation
TypingIndicator.propTypes = {
  names: PropTypes.arrayOf(PropTypes.string),
};

export default TypingIndicator;
